import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';

export const CompareBlockWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  margin-bottom: ${spacing.space24};
`;

export const CompareBlockTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CompareTitle = styled(Text)`
  margin: ${spacing.space16} 0 ${spacing.space32} 0;

  ${CompareBlockWrapper}:nth-of-type(n + 2) & {
    font-size: 1.75rem;
  }
`;

export const DesktopLinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 100px;

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const MobileLinkWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: flex;
    margin-top: ${spacing.space24};
    min-width: 100px;
  }
`;

export const CompareBlocks = styled.div`
  display: flex;
  gap: ${spacing.space24};
  width: 100%;
  align-items: flex-start;

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
  }
`;
